import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "row", "destroyField"]

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML
    const index = new Date().getTime() // unique index
    const html = content.replace(/NEW_INDEX/g, index)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-reminder-fields-target='row']")
    const destroyField = row.querySelector(
      "[data-reminder-fields-target='destroyField']",
    )

    if (destroyField && row.querySelector("input[name*='[id]']")) {
      // Existing record — mark for destruction
      destroyField.value = "1"
      row.classList.add("hidden")
    } else {
      // New record — remove from DOM
      row.remove()
    }
  }
}
